import React, { useState, useEffect, useContext, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  ListGroup,
  Modal,
  Form,
  Alert,
  InputGroup,
} from "react-bootstrap";
import axios from "axios";
import Header from "./Header";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { useNetworkStatus } from "../hooks/useNetworkStatus";
import {
  FaPlus,
  FaMinus,
  FaShoppingCart,
  FaCalendarAlt,
  FaCreditCard,
  FaRupeeSign,
  FaUtensils,
  FaReceipt,
  FaCheckCircle,
  FaClock,
  FaSearch,
  FaFilter,
} from "react-icons/fa";
import { ProductContext } from "../context/AppContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { KJUR } from "jsrsasign";

const generatePaymentToken = (paymentData) => {
  const header = { alg: "HS256", typ: "JWT" };

  const payload = {
    paymentData,
    exp: Math.floor(Date.now() / 1000) + (10 * 60), // 10 min expiry
  };

  return KJUR.jws.JWS.sign(
    "HS256",
    JSON.stringify(header),
    JSON.stringify(payload),
    "token" // 🔐 secret (backend me hona chahiye ideally)
  );
};


const API_ROOT =
  process.env.REACT_APP_MIRAI_API ??
  (process.env.NODE_ENV === "development"
    ? "/mirai-api"
    : "https://api.mirai.healthcare/api");
const STUDENT_DETAILS_BASE = `${API_ROOT}/student-details`;
const PAYMENT_REDIRECT_BASE = "https://admin.mirai.healthcare/pay-u-payment";

const formatOrderDate = (value) => {
  if (!value) return "Not selected";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "Not selected";
  return parsed.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
};

const getCategoryLabel = (item) => {
  if (!item?.ctgry) return "Standard menu";
  if (typeof item.ctgry === "string") return item.ctgry;
  if (typeof item.ctgry === "object") {
    if (typeof item.ctgry.name === "string") return item.ctgry.name;
    if (typeof item.ctgry.title === "string") return item.ctgry.title;
  }
  return "Standard menu";
};

const Canteen = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showSlowMsg, message } = useNetworkStatus(loading, 4000);
  const [quantities, setQuantities] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [showCartModal, setShowCartModal] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeMealTag, setActiveMealTag] = useState("All");
  const authtoken = localStorage.getItem("token");
  const { userId, classSectionId, setClassSectionId, Automationdata } = useContext(ProductContext);
  const [studentId, setStudentId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [studentProfile, setStudentProfile] = useState({});
  const navigate = useNavigate();

  const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};


  const [selectedOrderDate, setSelectedOrderDate] = useState(getTomorrowDate());


const minDate = getTomorrowDate();

  useEffect(() => {
    if (!userId) return;
    const fetchStudentData = async () => {
      try {
        const response = await axios.get(`https://api.mirai.healthcare/api/student?regs_id=${userId}`, {
          headers: { "x-auth": authtoken },
        });
        if (response.data.success && response.data.message.length > 0) {
          const studentData = response.data.message[0];
          setStudentId(studentData.id);
          setSessionId(studentData.session);
          setClassSectionId(studentData.class_section_id);
          setStudentProfile(studentData);
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
        Swal.fire({
          title: "Unable to load profile",
          text: "We couldn't load your profile details for canteen ordering.",
          icon: "error",
        });
      }
    };

    fetchStudentData();
  }, [userId, authtoken, setClassSectionId]);

  useEffect(() => {
    if (!authtoken || !selectedOrderDate) return;

    const fetchCanteenItems = async () => {
      const cacheKey = `canteen_items_${selectedOrderDate}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setItems(cached);
        setLoading(false);
      }
      try {
        if (!cached) setLoading(true);
        const formattedDate = moment(selectedOrderDate).format("DD-MM-YYYY");
        const response = await axios.get(
          `https://api.mirai.healthcare/api/student-details/canteen-item/day?date=${formattedDate}`,
          {
            headers: { "x-auth": authtoken },
          }
        );
        setItems(response.data.message || []);
        setCachedData(cacheKey, response.data.message || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCanteenItems();
  }, [authtoken, selectedOrderDate]);

  useEffect(() => {
    const computedTotal = items.reduce((sum, item) => {
      const qty = quantities[item.id] || 0;
      return sum + qty * (item.item_amt || 0);
    }, 0);
    setTotalPrice(computedTotal);
  }, [items, quantities]);

  const mealFilters = useMemo(() => {
    const tags = new Set();
    items.forEach((item) => {
      if (item.meal_type) {
        tags.add(item.meal_type);
      }
    });
    return ["All", ...Array.from(tags)];
  }, [items]);

  // const filteredItems = useMemo(() => {
  //   return items.filter((item) => {
  //     const matchesSearch =
  //       item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item.desc?.toLowerCase().includes(searchTerm.toLowerCase());
  //     const matchesTag =
  //       activeMealTag === "All" ||
  //       item.meal_type?.toLowerCase() === activeMealTag.toLowerCase();
  //     return matchesSearch && matchesTag;
  //   });
  // }, [items, searchTerm, activeMealTag]);

  const filteredItems = useMemo(() => {
  return items.filter((item) => {
    if (!selectedOrderDate) return false;

    const selectedDate = moment(selectedOrderDate, "YYYY-MM-DD");
    const formattedDate = selectedDate.format("DD-MM-YYYY");
    const weekDay = selectedDate.isoWeekday(); // 1–7 (Mon–Sun)

    // ✅ 1. Check specific date match
    const hasExactDate = item.weeks?.some(
      (w) => w.date === formattedDate && w.is_available
    );

    // ✅ 2. Check week_id match
    const hasWeekMatch = item.weeks?.some(
      (w) => w.week_id === weekDay && w.is_available
    );

    // ✅ 3. Check days match
    const hasDayMatch = Number(item.days) === weekDay;

    // ✅ FINAL condition
    return (
      (hasExactDate || hasWeekMatch || hasDayMatch) &&
      (
        item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.descp?.toLowerCase().includes(searchTerm.toLowerCase())
      ) &&
      (
        activeMealTag === "All" ||
        item.meal_type?.toLowerCase() === activeMealTag.toLowerCase()
      )
    );
  });
}, [items, selectedOrderDate, searchTerm, activeMealTag]);

  // const featuredItem = filteredItems[0] || items[0];

  const featuredItem = useMemo(() => {
  // 🔍 Agar user search kar raha hai
  if (searchTerm.trim()) {
    return filteredItems?.length > 0 ? filteredItems[0] : null;
  }

  // 🟢 Normal case (no search)
  return items?.length > 0 ? items[0] : null;
}, [searchTerm, filteredItems, items]);



  const totalItemsInCart = useMemo(() => {
    return Object.values(quantities).reduce((acc, qty) => acc + qty, 0);
  }, [quantities]);

  const cartItems = useMemo(() => {
    return items.filter((item) => quantities[item.id] > 0);
  }, [items, quantities]);

  const addToCart = (item) => {
    setQuantities((prev) => ({
      ...prev,
      [item.id]: (prev[item.id] || 0) + 1,
    }));

    Swal.fire({
      title: "Added to Cart!",
      text: `${item.title} added to your cart`,
      icon: "success",
      toast: true,
      position: "top-end",
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const handleIncrement = (itemId) => {
    setQuantities((prev) => ({
      ...prev,
      [itemId]: (prev[itemId] || 0) + 1,
    }));
  };

  const handleDecrement = (itemId) => {
    setQuantities((prev) => {
      if (!prev[itemId]) return prev;
      const updatedQty = prev[itemId] - 1;
      if (updatedQty <= 0) {
        const updated = { ...prev };
        delete updated[itemId];
        return updated;
      }
      return { ...prev, [itemId]: updatedQty };
    });
  };

  const handleCartClick = () => setShowCartModal(true);
  const closeCartModal = () => setShowCartModal(false);

  const clearCart = () => {
    if (totalItemsInCart === 0) return;
    setQuantities({});
    Swal.fire({
      title: "Cart Cleared",
      text: "All items removed from cart",
      icon: "success",
      toast: true,
      position: "top-end",
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const handlePayment = async () => {
    if (!selectedOrderDate) {
      Swal.fire({
        title: "Select Date",
        text: "Please select an order date.",
        icon: "warning",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    if (cartItems.length === 0) {
      Swal.fire({
        title: "Empty Cart",
        text: "Your cart is empty.",
        icon: "warning",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    if (!studentId || !sessionId || !classSectionId) {
      Swal.fire({
        title: "Profile incomplete",
        text: "We could not find your student details to place this order.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    setPaymentLoading(true);
    try {
      const formattedOrderDate = new Date(selectedOrderDate).toISOString();

const payload = {
  user_type: "student",
  amt: totalPrice,
  user_id: studentId,
  cls_sec_id: classSectionId,
  rmk: "Lunch order",
  status: "pending",
  pay_status: "unpaid",
  session_id: Number(sessionId),
  order_for: formattedOrderDate,
  is_act: true,
  ord_line: cartItems.map((item) => ({
    amt: item.item_amt * quantities[item.id],
    qty: quantities[item.id],
    cls_sec_id: classSectionId,
    ctgry_id: item.id,
    user_id: studentId,
    rmk: item.title,
    is_act: true,
    created_by: 1,
    order_for: formattedOrderDate,
  })),
};


      const response = await axios.post(
        `https://api.mirai.healthcare/api/student-details/canteen-order`,
        payload,
        {
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const canteenOrderId = response?.data?.message?.CanteenOrder?.id;
        await Swal.fire({
          title: "Order Placed!",
          text: "Order placed successfully! Redirecting to payment.",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });

        const studentFullName = studentProfile.student_full_name || "";
        const allMobiles = [
          studentProfile.contact_phone,
         
        ]
          .filter(Boolean)
          .join(", ");
        const allEmails = [
          studentProfile.contact_email,
        ]
          .filter(Boolean)
          .join(", ");

        const paymentDetails = {
          amount: totalPrice,
          productinfo: "Canteen Order",
          firstname: studentFullName,
          email: allEmails,
          phone: allMobiles,
          canteenId: canteenOrderId,
          paymentMethod: Automationdata?.data?.[0]?.PaymentMethod,
        };
const paymentToken = generatePaymentToken(paymentDetails);

// const query = new URLSearchParams({
//   paymentToken: paymentToken,
//   authToken: authtoken || "",
// }).toString();


        const query = new URLSearchParams({
          ...paymentDetails,
          authToken: authtoken || "",
        }).toString();

        window.open(`${window.location.origin}/pay-u-payment?${query}`, "_blank");

        setQuantities({});
        setShowCartModal(false);
        navigate("/orderhistory");
      } else {
        Swal.fire({
          title: "Error",
          text: `Server Error: ${response.status}`,
          icon: "error",
          confirmButtonColor: "#3085d6",
        });
      }
    } catch (error) {
      console.error("Payment API Error:", error.response?.data || error.message);
      Swal.fire({
        title: "Payment Failed",
        text: error.response?.data?.message || "Payment processing failed.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    } finally {
      setPaymentLoading(false);
    }
  };


  const renderQuantityControls = (item) => (
    <div className="cant-qty">
      <button
        type="button"
        className="cant-qty__btn"
        onClick={() => handleDecrement(item.id)}
        aria-label="Decrease quantity"
      >
        <FaMinus />
      </button>
      <span className="cant-qty__value">{quantities[item.id]}</span>
      <button
        type="button"
        className="cant-qty__btn is-add"
        onClick={() => handleIncrement(item.id)}
        aria-label="Increase quantity"
      >
        <FaPlus />
      </button>
    </div>
  );

  // Menu pages in on mobile instead of rendering every item at once
  const ITEMS_PER_PAGE = 8;
  const [visibleItemCount, setVisibleItemCount] = useState(ITEMS_PER_PAGE);

  const visibleItems = filteredItems.slice(0, visibleItemCount);
  const remainingItems = filteredItems.length - visibleItems.length;

  useEffect(() => {
    setVisibleItemCount(ITEMS_PER_PAGE);
  }, [searchTerm, selectedOrderDate, items]);

  const noItemsAvailable = !loading && items.length === 0;
  const noFilteredResults = !loading && items.length > 0 && filteredItems.length === 0;

  console.log(Automationdata?.data?.[0]?.cntin_odr_udr_days, 'Days1');

 const today = moment().format("YYYY-MM-DD");

 
 const todayDate = new Date();
const tomorrow = new Date(todayDate);
tomorrow.setDate(todayDate.getDate() + 1);

 


// const maxDate = Automationdata?.data?.[0]?.cntin_odr_udr_days
//   ? moment()
//       .add(Automationdata.data[0].cntin_odr_udr_days - 1, "days")
//       .format("YYYY-MM-DD")
//   : today;

const maxDate = Automationdata?.data?.[0]?.cntin_odr_udr_days
  ? moment()
      .add(1, "days") // 👈 start from tomorrow
      .add(Automationdata.data[0].cntin_odr_udr_days - 1, "days")
      .format("YYYY-MM-DD")
  : minDate; // 👈 fallback bhi tomorrow rakho

    const [holidayCalendar, setHolidayCalendar] = useState([]);
  useEffect(() => {
      const fetchHolidayCalendar = async () => {
        if (!sessionId || !classSectionId) return;
        try {
          const response = await axios.get(
            `https://api.mirai.healthcare/api/masters/holidaycalender?session_id=${sessionId}&class_section_id=${classSectionId}`,
            {
              headers: {
                "x-auth": authtoken,
              },
            }
          );
          if (response?.data?.success) {
            setHolidayCalendar(response?.data?.data || []);
          } else {
            setHolidayCalendar([]);
          }
        } catch (error) {
          console.error("Error fetching holiday calendar:", error);
          setHolidayCalendar([]);
        }
      };
  
      fetchHolidayCalendar();
    }, [sessionId, classSectionId, authtoken]);
  

  // ✅ Sunday check
const isSunday = (date) => moment(date).day() === 0;

const holidayDateMap = useMemo(() => {
    const map = {};

    holidayCalendar.forEach((holiday) => {
      const start = moment(holiday.start_date).startOf("day");
      const end = moment(holiday.end_date || holiday.start_date).startOf("day");
      if (!start.isValid()) return;

      const lastDate = end.isValid() ? end : start;
      const current = start.clone();
      while (current.isSameOrBefore(lastDate, "day")) {
        const key = current.format("YYYY-MM-DD");
        if (!map[key]) map[key] = [];
        map[key].push({
          title: holiday.title || "Holiday",
          type: holiday.type || "",
          description: holiday.description || "",
        });
        current.add(1, "day");
      }
    });

    return map;
  }, [holidayCalendar]);

// ✅ Holiday list
const getHolidayListByDate = (date) => {
  const key = moment(date).format("YYYY-MM-DD");
  return holidayDateMap[key] || [];
};

// ❌ Blocked dates
const isDateBlocked = (date) => {
  return isSunday(date) || getHolidayListByDate(date).length > 0;
};

// ✅ Selectable date
const isSelectableDate = (date) => {
  const todayDate = moment().startOf("day");
  return moment(date).isAfter(todayDate, "day") && !isDateBlocked(date);
};
 
const getDayClassName = (date) => {
  if (isSunday(date)) return "holiday-sunday";
  if (getHolidayListByDate(date).length > 0) return "holiday-day";
  return "";
};

const getNextValidDate = () => {
  let date = moment().add(1, "days"); // start from tomorrow

  // loop until valid date mil jaye
  while (isDateBlocked(date)) {
    date = date.add(1, "days");
  }

  return date.format("YYYY-MM-DD");
};

useEffect(() => {
  if (holidayCalendar.length > 0) {
    const validDate = getNextValidDate();
    setSelectedOrderDate(validDate);
  }
}, [holidayCalendar]);

const handleDateChange = async (date) => {
  const newDate = moment(date).format("YYYY-MM-DD");

  if (newDate === selectedOrderDate) return;

  if (totalItemsInCart > 0) {
    const result = await Swal.fire({
      title: "Change Date?",
      text: "Changing date will clear your cart.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change",
    });

    if (!result.isConfirmed) return;

    clearCart();
  }

  setSelectedOrderDate(newDate);
};

  return (
    <div className="page-wrapper min-vh-100 cant-page">
      <Header quantities={quantities} handleCartClick={handleCartClick} />

      <div className="cant-head">
        <div className="cant-head__left">
          <span className="cant-head__icon">
            <FaUtensils />
          </span>
          <div>
            <h5>Canteen Menu</h5>
            <span>Fresh meals prepared daily</span>
          </div>
        </div>

        <div className="cant-head__actions">
          <button type="button" className="cant-head__history" onClick={() => navigate("/orderhistory")}>
            <FaReceipt />
            Orders
          </button>
          <button type="button" className="cant-cart-btn" onClick={handleCartClick}>
            <FaShoppingCart />
            Cart
            {totalItemsInCart > 0 && <span className="cant-cart-btn__count">{totalItemsInCart}</span>}
          </button>
        </div>
      </div>

<div className="py-4">
      <Container fluid >
        <div className="cant-stats">
          <div className="cant-stat">
            <span className="cant-stat__label">Menu items</span>
            <strong className="cant-stat__value">{items.length}</strong>
          </div>
          <div className="cant-stat">
            <span className="cant-stat__label">In cart</span>
            <strong className="cant-stat__value is-cart">{totalItemsInCart}</strong>
          </div>
          <div className="cant-stat cant-stat--wide">
            <span className="cant-stat__label">Delivery date</span>
            <strong className="cant-stat__value is-date">{formatOrderDate(selectedOrderDate)}</strong>
          </div>
        </div>

        {/* <Card className="border-0 shadow-sm mb-4">
          <Card.Body>
            <Row className="g-3 align-items-center">
              <Col lg={6}>
                <InputGroup>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search sandwiches, juices, combos..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </InputGroup>
              </Col>
              <Col lg={6} className="text-lg-end">
                <div className="d-inline-flex flex-wrap gap-2 align-items-center">
                  <span className="text-muted d-flex align-items-center gap-1 small">
                    <FaFilter /> Sort by meal
                  </span>
                  {mealFilters.map((filter) => (
                    <Button
                      key={filter}
                      size="sm"
                      variant={activeMealTag === filter ? "primary" : "outline-secondary"}
                      className="rounded-pill"
                      onClick={() => setActiveMealTag(filter)}
                    >
                      {filter}
                    </Button>
                  ))}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card> */}
        <div className="cant-toolbar">
          <div className="cant-field">
            <label>
              <FaCalendarAlt />
              Order date
            </label>
            <DatePicker
              selected={selectedOrderDate ? new Date(selectedOrderDate) : null}
              onChange={handleDateChange}
              dateFormat="yyyy-MM-dd"
              className="form-control cant-date"
              minDate={moment().add(1, "days").toDate()}
              maxDate={maxDate}
              filterDate={isSelectableDate}
              dayClassName={getDayClassName}
              placeholderText="Select order date"
            />
          </div>

          <div className="cant-field">
            <label>
              <FaSearch />
              Search
            </label>
            <div className="cant-search">
              <FaSearch className="cant-search__icon" />
              <input
                type="text"
                placeholder="Search sandwiches, juices, combos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  type="button"
                  className="cant-search__clear"
                  onClick={() => setSearchTerm("")}
                  aria-label="Clear search"
                >
                  &times;
                </button>
              )}
            </div>
          </div>
        </div>

        {!loading && featuredItem && (
          <div className="cant-featured">
            <div className="cant-featured__info">
              <span className="cant-featured__tag">Today's pick</span>
              <h5>{featuredItem.title || "Featured Meal"}</h5>
              <p>{featuredItem.desc || "A popular choice loved by students every day."}</p>
              <div className="cant-featured__meta">
                <span><FaClock /> {featuredItem.service_time || "Served today"}</span>
                <span><FaUtensils /> {featuredItem.meal_type || "Daily menu"}</span>
              </div>
            </div>
            <div className="cant-featured__buy">
              <span className="cant-featured__from">Starts at</span>
              <div className="cant-featured__price">
                <FaRupeeSign />
                {featuredItem.item_amt}
              </div>
              <button type="button" className="cant-featured__btn" onClick={() => addToCart(featuredItem)}>
                <FaPlus /> Quick add
              </button>
            </div>
          </div>
        )}

        {loading ? (
          <div className="cant-state">
            <Spinner animation="border" variant="primary" size="sm" />
            <p>Loading menu...</p>
          </div>
        ) : noItemsAvailable ? (
          <div className="cant-state">
            <FaUtensils className="cant-state__icon" />
            <p className="cant-state__title">No items available</p>
            <p>Check back later for today's menu.</p>
          </div>
        ) : noFilteredResults ? (
          <div className="cant-state">
            <FaSearch className="cant-state__icon" />
            <p className="cant-state__title">No matches found</p>
            <p>Try a different keyword.</p>
          </div>
        ) : (
          <>
          <div className="cant-grid">
            {visibleItems.map((item) => {
              const inCart = Boolean(quantities[item.id]);

              return (
                <div className={`cant-card ${inCart ? "is-in-cart" : ""}`} key={item.id}>
                  <div className="cant-card__media">
                    <img
                      src={item?.url?.link}
                      alt={item.title}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    {item.meal_type && (
                      <span className="cant-card__meal">{item.meal_type}</span>
                    )}
                    {inCart && (
                      <span className="cant-card__added">
                        <FaCheckCircle /> In cart
                      </span>
                    )}
                  </div>

                  <div className="cant-card__body">
                    <h6 className="cant-card__title" title={item.title}>
                      {item.title}
                    </h6>

                    <div className="cant-card__meta">
                      <span><FaClock /> {item.service_time || "Served today"}</span>
                      <span><FaReceipt /> {getCategoryLabel(item)}</span>
                    </div>

                    <div className="cant-card__foot">
                      <div className="cant-card__price">
                        <FaRupeeSign />
                        {item.item_amt}
                      </div>

                      {inCart ? (
                        renderQuantityControls(item)
                      ) : (
                        <button
                          type="button"
                          className="cant-add"
                          onClick={() => addToCart(item)}
                        >
                          <FaPlus /> Add
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {remainingItems > 0 && (
            <button
              type="button"
              className="cant-more"
              onClick={() => setVisibleItemCount((prev) => prev + ITEMS_PER_PAGE)}
            >
              Load More
              <span>({remainingItems} left)</span>
            </button>
          )}
          </>
        )}
      </Container>
      </div>

      <Modal show={showCartModal} onHide={closeCartModal} centered size="lg">
        <Modal.Header closeButton className="border-0 bg-light">
          <Modal.Title className="fw-bold d-flex align-items-center gap-2">
            <FaShoppingCart />
            Your Order Summary
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="border-0 bg-light mb-4">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h6 className="fw-bold mb-0 d-flex align-items-center gap-2">
                    <FaCalendarAlt className="text-primary" />
                    Item List
                  </h6>
                  <small className="text-muted">
                    Choose the date for your meal delivery
                  </small>
                </div>
                <Button variant="link" className="text-danger text-decoration-none p-0" onClick={clearCart}>
                  Clear cart
                </Button>
              </div>




            </Card.Body>
          </Card>

          {totalItemsInCart === 0 ? (
            <Alert variant="info" className="text-center py-4 border-0">
              <FaShoppingCart className="fs-1 text-muted mb-3" />
              <h5>Your cart is empty</h5>
              <p className="mb-0">Add some delicious items from our menu!</p>
            </Alert>
          ) : (
            <>
              <ListGroup className="mb-3">
                {cartItems.map((item) => (
                  <ListGroup.Item
                    key={item.id}
                    className="border-0 border-bottom d-flex justify-content-between align-items-center px-0"
                  >
                    <div>
                      <h6 className="fw-bold mb-1">{item.title}</h6>
                      <div className="small text-muted d-flex gap-3 flex-wrap">
                        <span>₹{item.item_amt} each</span>
                        {item.meal_type && <span>{item.meal_type}</span>}
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <div className="d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="p-0 rounded-circle"
                          style={{ width: "26px", height: "26px" }}
                          onClick={() => handleDecrement(item.id)}
                        >
                          <FaMinus size={10} />
                        </Button>
                        <span className="fw-bold mx-2">{quantities[item.id]}</span>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="p-0 rounded-circle"
                          style={{ width: "26px", height: "26px" }}
                          onClick={() => handleIncrement(item.id)}
                        >
                          <FaPlus size={10} />
                        </Button>
                      </div>
                      <div className="text-end">
                        <h6 className="fw-bold text-success mb-0">
                          ₹{item.item_amt * quantities[item.id]}
                        </h6>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>

              <Card className="border-0 bg-success bg-opacity-10">
                <Card.Body className="py-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="text-muted text-uppercase small">Total Amount</div>
                      <h4 className="fw-bold mb-0">{totalItemsInCart} item(s)</h4>
                    </div>
                    <div className="d-flex align-items-baseline gap-1">
                      <FaRupeeSign className="text-success" />
                      <h3 className="mb-0 text-success">{totalPrice}</h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="outline-secondary me-2" onClick={closeCartModal}>
            Continue Shopping
          </Button>
          <Button
            variant="primary"
            onClick={handlePayment}
            disabled={totalItemsInCart === 0 || paymentLoading}
            className="px-4 d-flex align-items-center gap-2"
          >
            {paymentLoading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Processing...
              </>
            ) : (
              <>
                <FaCreditCard />
                Pay ₹{totalPrice}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .react-datepicker__day.leave-day-blocked {
          background: #fce8e8;
          color: #a94442;
          border-radius: 999px;
          font-weight: 600;
        }

        .react-datepicker__day.leave-day-sunday {
          color: #d9534f;
        }

        .react-datepicker__day.leave-day-holiday {
          border: 1px solid #f0ad4e;
        }
          .holiday-sunday {
  color: red !important;
}

.holiday-day {
  background-color: #ffeeba !important;
  border-radius: 50%;
}
      `}</style>
    </div>
  );
};


export default Canteen;
